module.exports = __webpack_public_path__ + "img/423.74910904.png";